import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'speedRenderColor',
})
export class SpeedometerRenderColorPipe implements PipeTransform {

  transform(value: number, maxValue: number): unknown {
    const percentage = value / maxValue;

    if(percentage < 1 / 3 *2) return '#02b502';
    if(percentage < 10 / 12) return '#bfb006';
    return '#d33b05';
  }

}
